<template>
  <div class="segment-watermark-panel">
    <div class="segment-watermark-panel__header">
      <span>视频水印</span>
      <el-switch
        :value="enabled"
        :disabled="disabled"
        @input="$emit('update:enabled', $event)"
      />
    </div>
    <p class="segment-watermark-panel__hint">
      水印将烧录到每个切片视频画面中，建议使用简短文字。
    </p>
    <div v-if="enabled" class="segment-watermark-panel__body">
      <el-form label-width="88px" size="small">
        <el-form-item label="水印文字">
          <el-input
            :value="text"
            :disabled="disabled"
            maxlength="64"
            show-word-limit
            placeholder="如：@我的账号"
            @input="$emit('update:text', $event)"
          />
        </el-form-item>
        <el-form-item label="文字颜色">
          <div class="color-picker-row">
            <el-color-picker
              v-model="textColorProxy"
              color-format="hex"
              :disabled="disabled"
            />
            <span class="color-value">{{ textColor || '#FFFFFF' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="文字大小">
          <el-select
            :value="fontSize"
            :disabled="disabled"
            @input="$emit('update:fontSize', $event)"
          >
            <el-option
              v-for="item in fontSizeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="位置">
          <el-select
            :value="position"
            :disabled="disabled"
            placeholder="选择位置"
            @input="$emit('update:position', $event)"
          >
            <el-option
              v-for="item in positionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="文字描边">
          <el-switch
            :value="textStroke"
            :disabled="disabled"
            @input="$emit('update:textStroke', $event)"
          />
        </el-form-item>
        <el-form-item v-if="textStroke" label="描边颜色">
          <div class="color-picker-row">
            <el-color-picker
              v-model="textStrokeColorProxy"
              color-format="hex"
              :disabled="disabled"
            />
            <span class="color-value">{{ textStrokeColor || '#000000' }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { WATERMARK_POSITION_OPTIONS, WATERMARK_POSITIONS } from '../constants/watermarkPositions';
import { WATERMARK_FONT_SIZE_DEFAULT, WATERMARK_FONT_SIZE_OPTIONS } from '../constants/textFontSizes';
import { normalizeHexColor, normalizeStrokeHexColor } from '../utils/color';

export default {
  name: 'SegmentWatermarkPanel',
  props: {
    enabled: { type: Boolean, default: false },
    text: { type: String, default: '' },
    textColor: { type: String, default: '#FFFFFF' },
    fontSize: { type: Number, default: WATERMARK_FONT_SIZE_DEFAULT },
    position: { type: String, default: WATERMARK_POSITIONS.BOTTOM_RIGHT },
    textStroke: { type: Boolean, default: true },
    textStrokeColor: { type: String, default: '#000000' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      positionOptions: WATERMARK_POSITION_OPTIONS,
      fontSizeOptions: WATERMARK_FONT_SIZE_OPTIONS,
    };
  },
  computed: {
    textColorProxy: {
      get() {
        return this.textColor || '#FFFFFF';
      },
      set(value) {
        this.$emit('update:textColor', normalizeHexColor(value, '#FFFFFF'));
      },
    },
    textStrokeColorProxy: {
      get() {
        return this.textStrokeColor || '#000000';
      },
      set(value) {
        this.$emit('update:textStrokeColor', normalizeStrokeHexColor(value));
      },
    },
  },
};
</script>

<style scoped>
.segment-watermark-panel {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafafa;
}

.segment-watermark-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.segment-watermark-panel__hint {
  margin: 8px 0 0;
  color: #909399;
  font-size: 12px;
}

.segment-watermark-panel__body {
  margin-top: 12px;
}

.color-picker-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-value {
  font-size: 12px;
  color: #606266;
}
</style>
